import { EntityId } from "@jackfruit/common"
import { useApplicationState } from "~/hooks/useApplicationState"
import { useLineItem } from "~/hooks/useLineItem"
import { useProductImages } from "~/hooks/useProductImages"
import { useProductPage } from "~/hooks/useProductPage"
import { photoBookFindImageForPage } from "../PhotoBookUtils"

export const useFrameImageForPage = (
  lineItemId: EntityId,
  productPageId: EntityId
) => {
  const { language } = useApplicationState()
  const { productPage } = useProductPage(productPageId)
  const { lineItem, product } = useLineItem(lineItemId)
  const { productImages } = useProductImages(product?.id)
  const { productPageIds } = lineItem

  let productImage = null
  if (productPage) {
    productImage = photoBookFindImageForPage(
      productPage,
      productImages,
      productPageIds,
      language
    )
  }

  return { productImage }
}
